import { HilyteEndPoints } from "apis/EndPoints/HilyteEndPoints";
import { Network } from "../Network";
import { WarehouseEndPoints } from "apis/EndPoints/WarehouseEndPoints";

export class HilyteService {
  static hilytePageAccessLevel(data = {}) {
    return Network.fetch(
      HilyteEndPoints.hilytePageAccessLevel.url(data?.company),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: data?.code,
          From: data?.loginEmail,
        },
        method: HilyteEndPoints.hilytePageAccessLevel.method,
      },
    );
  }

  static getAllUsersPDF(data = {}) {
    return Network.fetch(HilyteEndPoints.getAllUsersPDF.url(data?.company), {
      headers: {
        "Content-type": "application/json",
        Authorization: data?.code,
        From: data?.loginEmail,
      },
      method: HilyteEndPoints.getAllUsersPDF.method,
    });
  }

  static getPDF(data = {}) {
    return Network.fetch(
      HilyteEndPoints.getPDF.url(data?.company, data?.pdfID),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: data?.code,
          From: data?.loginEmail,
        },
        method: HilyteEndPoints.getPDF.method,
      },
    );
  }

  static getSinglePDFStatus(data = {}) {
    return Network.fetch(
      HilyteEndPoints.getSinglePDFStatus.url(data?.company, data?.pdfID),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: data?.code,
          From: data?.loginEmail,
        },
        method: HilyteEndPoints.getSinglePDFStatus.method,
      },
    );
  }

  static extractSectionsFromPDF(data = {}) {
    return Network.fetch(
      HilyteEndPoints.extractSectionsFromPDF.url(data?.company, data?.pdfID),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: data?.code,
          From: data?.loginEmail,
        },
        method: HilyteEndPoints.extractSectionsFromPDF.method,
      },
    );
  }

  static deletePDF(data = {}) {
    return Network.fetch(
      HilyteEndPoints.deletePDF.url(data?.company, data?.pdfID),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: data?.code,
          From: data?.loginEmail,
        },
        method: HilyteEndPoints.deletePDF.method,
      },
    );
  }

  static updatePDFInfo(data = {}) {
    return Network.fetch(
      HilyteEndPoints.updatePDFInfo.url(data?.company, data?.pdfID),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: data?.code,
          From: data?.loginEmail,
        },
        method: HilyteEndPoints.updatePDFInfo.method,
        body: JSON.stringify(data),
      },
    );
  }

  static extractSubmittalsFromPDF({ loginEmail, code, data, company, pdfID }) {
    return Network.fetch(
      HilyteEndPoints.extractSubmittalsFromPDF.url(company, pdfID),
      {
        method: HilyteEndPoints.extractSubmittalsFromPDF.method,
        headers: {
          Authorization: code,
          From: loginEmail,
        },
        body: JSON.stringify(data),
      },
    );
  }

  static extractPortionSubmittals({
    company,
    loginEmail,
    code,
    formData,
    signal,
  }) {
    return Network.fetchUpload(
      HilyteEndPoints.extractPortionSubmittals.url(company),
      {
        method: HilyteEndPoints.extractPortionSubmittals.method,
        headers: {
          Authorization: code,
          From: loginEmail,
        },
        body: formData,
        signal: signal, // Add signal support
      },
    );
  }

  static uploadPDF({
    company,
    loginEmail,
    code,
    formData,
    onUploadProgress,
    signal,
  }) {
    return Network.fetchUpload(HilyteEndPoints.uploadPDF.url(company), {
      method: HilyteEndPoints.uploadPDF.method,
      headers: {
        Authorization: code,
        From: loginEmail,
      },
      onUploadProgress: onUploadProgress,
      body: formData,
      signal: signal, // Add signal support here
    });
  }
}
